import { render, staticRenderFns } from "./VFormModifiedStored.vue?vue&type=template&id=4ed91bb5&scoped=true"
import script from "./VFormModifiedStored.vue?vue&type=script&lang=js"
export * from "./VFormModifiedStored.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed91bb5",
  null
  
)

export default component.exports